import Remote from '@/remote/Remote';
import RemoteMock from '@/remote/RemoteMock';
import RemoteFirebase from '@/remote/RemoteFirebase';

let cachedRemote: Remote | undefined;

export default function remote(): Remote {
    if (cachedRemote === undefined) {
        if (process.env.TEST_ENV === 'mock' || process.env.NODE_ENV === 'mock') {
            // console.log('Mock environment')
            cachedRemote = new RemoteMock();
        } else if (process.env.TEST_ENV === 'hot') {
            cachedRemote = new RemoteFirebase('test');
        } else if (process.env.NODE_ENV === 'development') {
            cachedRemote = new RemoteFirebase('devl');
        } else if (process.env.NODE_ENV === 'production') {
            cachedRemote = new RemoteFirebase('prod');
        } else {
            throw new Error(`Invalid parameter combination. NODE_ENV = ${process.env.NODE_ENV}, TEST_ENV = ${process.env.TEST_ENV}.`);
        }
    }
    return (cachedRemote as Remote);
}

declare global {
    // noinspection JSUnusedGlobalSymbols
    interface Window {
        debugRemote() : void;
    }
}

window.debugRemote = () => remote().debugState();
